(() => {
  if (window.noLayerMaterialDialogReady) return;
  window.noLayerMaterialDialogReady = true;
  let opener;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-material-report-open]');
    const dialog = document.getElementById('nolayer-material-dialog');
    if (!trigger || !dialog || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    opener = trigger;
    const frame = dialog.querySelector('[data-report-src]');
    if (frame && !frame.getAttribute('src')) frame.src = frame.dataset.reportSrc;
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('nl-report-open');
  });
  const dialog = document.getElementById('nolayer-material-dialog');
  if (!dialog) return;
  dialog.addEventListener('click', (event) => {
    const outside = event.target === dialog && (() => {
      const rect = dialog.getBoundingClientRect();
      return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
    })();
    if (outside || event.target.closest('[data-report-close]')) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('nl-report-open');
    if (opener && opener.isConnected) opener.focus({preventScroll:true});
  });
})();
